import React, { useState, useEffect, useRef } from 'react';
import { IoIosMenu } from "react-icons/io";
import { BiCaretDown } from "react-icons/bi";
import message from "../../../assets/images/icons/header/message.svg"
import '../../../../src/index.css';
import home from "../../../assets/images/icons/menu/Home.svg"
import followUp from "../../../assets/images/icons/menu/follow-up.svg"
import provider from "../../../assets/images/icons/menu/provider.svg"
import resources from "../../../assets/images/icons/menu/resources.svg"
import manuals from "../../../assets/images/icons/menu/manuals.svg"
import doc from "../../../assets/images/icons/menu/Doc.svg"
import us from "../../../assets/images/icons/menu/us.svg"
import config from "../../../assets/images/icons/menu/Config.svg"
import trabajador from "../../../assets/images/icons/menu/trabajador.png"
import record from "../../../assets/images/icons/menu/record.svg"
import announcement from "../../../assets/images/icons/menu/announcement.svg"
import www from "../../../assets/images/icons/menu/www.svg"
import logo from "../../../assets/images/logos/logo-form-login.svg"
import Programate from '../footer';
import { useNavigate, useLocation } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import Notification from '../../shared/notificacion';
import { useAuth } from '../../../context/auth';
import { getEvaluationSupplier } from '../../../client/evaluationProvider';
import { filterMenuByPermissions, PERMISSION_MAPPING, hasPermission } from '../../../context/permissionsMapping';
import { patch } from '@mui/material';
import { postUserSupplierAdherence } from '../../../client/userAdherence';

const Menu = ({ isMenuOpen, toggleMenu, isPageError = false }) => {
  const [isFollowUpDropdownOpen, setIsFollowUpDropdownOpen] = useState(false);
  const [isProveedoresDropdownOpen, setIsProveedoresDropdownOpen] = useState(false);
  const [isRecursosDropdownOpen, setIsRecursosDropdownOpen] = useState(false);
  const [isDocumentacionDropdownOpen, setIsDocumentacionDropdownOpen] = useState(false);
  const [isConocenosDropdownOpen, setIsConocenosDropdownOpen] = useState(false);
  const [isAnunciosDropdownOpen, setIsAnunciosDropdownOpen] = useState(false);
  const [isRegistroDropdownOpen, setIsRegistroDropdownOpen] = useState(false);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [activeOption, setActiveOption] = useState(null);

  const [countMessage, setCountMessage] = useState(2);

  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [hasEvaluation, setHasEvaluation] = useState(true);
  const { user, logout, permissions } = useAuth();
  const roleId = user?.roleId;
  const supplierId = user?.supplierId;

  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef(null); 
  const menuButtonRef = useRef(null); 

  const isPathActive = (path) => {
    if (!path) return false;
    
    if (path === location.pathname) return true;
    
    if (location.pathname.startsWith(path) && path !== '/') return true;
    
    return false;
  };

  useEffect(() => {
    const currentPath = location.pathname;
    
    const checkAndOpenDropdowns = () => {
      // SEGUIMIENTO OC - ATC
      if (currentPath.includes('/oc') || 
          currentPath.includes('/compradores') ||
          currentPath.includes('/mis-oc') ||
          currentPath.includes('/oc-historico') ||
          currentPath.includes('/atc') ||
          currentPath.includes('/mis-atc') ||
          currentPath.includes('/facturacion') ||
          currentPath.includes('/mi-facturacion')
        ) {
        setIsFollowUpDropdownOpen(true);
      }
      
      // PROVEEDORES
      if (currentPath.includes('/evaluacion') || 
          currentPath.includes('/beneficios') ||
          currentPath.includes('/ranking') ||
          currentPath.includes('/mi-evaluacion') ||
          currentPath.includes('/mis-beneficios') ||
          currentPath.includes('/criterios-de-evaluacion')) {
        setIsProveedoresDropdownOpen(true);
      }
      
      // DOCUMENTACIÓN
      if (currentPath.includes('/documentos') || 
          currentPath.includes('/temporadas') ||
          currentPath.includes('/requisitos-de-inicio-de-temporada') ||
          currentPath.includes('/encuestas') ||
          currentPath.includes('/historico-de-encuestas') ||
          currentPath.includes('/mis-encuestas')) {
        setIsDocumentacionDropdownOpen(true);
      }
      
      // CONÓCENOS
      if (currentPath.includes('/conocenos') || 
          currentPath.includes('/detalle-noticia') ||
          currentPath.includes('/crear-detalle-noticia') ||
          currentPath.includes('/actualizar-noticia')) {
        setIsConocenosDropdownOpen(true);
      }
      
      // GESTIÓN DE USUARIOS
      if (currentPath.includes('/registro-usuario') || 
          currentPath.includes('/lista-') ||
          currentPath.includes('/prev-lista-')) {
        setIsRegistroDropdownOpen(true);
      }
      
      // ANUNCIOS
      if (currentPath.includes('/publicar-anuncio') || 
          currentPath.includes('/historial-anuncios')) {
        setIsAnunciosDropdownOpen(true);
      }

      //RECURSOS
      if (currentPath.includes('/gestion-de-citas') || 
          currentPath.includes('/gestion-de-horarios') ||
          currentPath.includes('/agendar-cita')) {
      setIsRecursosDropdownOpen(true);
      }

    };
    
    checkAndOpenDropdowns();
  }, [location.pathname]);

  useEffect(() => {
    const currentPath = location.pathname;
    
    const determineActiveOption = () => {
      const allMenuItems = [...adminMenuItemsBase, ...providerMenuItemsBase];
      
      for (const item of allMenuItems) {
        if (item.path && isPathActive(item.path)) {
          return item.text;
        }
        
        if (item.subMenu) {
          for (const subItem of item.subMenu) {
            if (subItem.path && isPathActive(subItem.path)) {
              return subItem.text;
            }
          }
        }
      }
      
      return null;
    };
    
    const activeOpt = determineActiveOption();
    if (activeOpt) {
      setActiveOption(activeOpt);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (roleId !== 1 && supplierId) {
      checkSupplierEvaluation();
    }
  }, [roleId, supplierId]);



  const toggleNotification = () => {
      setIsNotificationOpen(!isNotificationOpen);
  };

  const checkSupplierEvaluation = async () => {
    try {
      const response = await getEvaluationSupplier(supplierId);
      setHasEvaluation(true);
      localStorage.setItem('hasEvaluation', 'true');
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setHasEvaluation(false);
        localStorage.setItem('hasEvaluation', 'false');
      } else {
        console.error('Error al verificar evaluación:', error);
        setHasEvaluation(true);
        localStorage.setItem('hasEvaluation', 'true');
      }
    }
  };

  const handleResize = () => {
    const newWidth = window.innerWidth;
    setScreenWidth(newWidth);

    if (newWidth < 1024 && isMenuOpen) {
      toggleMenu(false);
    }
    else if (newWidth > 1024 && !isMenuOpen) {
      toggleMenu(true);
    }
  };

  useEffect(() => {
    handleResize(); 
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    useEffect(() => {
    if (screenWidth < 1024 && isMenuOpen) {
      const handleClickOutside = (event) => {
        const clickedOutside =
          menuRef.current &&
          !menuRef.current.contains(event.target) &&
          !menuButtonRef.current.contains(event.target);


        if (clickedOutside) {
          toggleMenu(false);
        }
      };

      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [screenWidth, isMenuOpen, toggleMenu]);



const handleOptionClick = (itemText, pathOrHref, target = "_self", moduleId = null) => {

  setActiveOption(itemText);
  
  if (moduleId && user?.id) {
    const registerAdherence = async () => {
      try {
        await postUserSupplierAdherence(user.id, moduleId);
      } catch (error) {
        console.error(`Error registrando adherencia para módulo ${moduleId}:`, error);
      }
    };
    registerAdherence();
  }
  
  if (target === "_blank") {
    window.open(pathOrHref, "_blank");
  } else {
    navigate(pathOrHref);
  }
  
  if (window.innerWidth < 1024) {
    toggleMenu(false);
  }
};

  const handleDropdownClick = (dropdownType) => {
    setIsFollowUpDropdownOpen(false);
    setIsProveedoresDropdownOpen(false);
    setIsRecursosDropdownOpen(false);
    setIsDocumentacionDropdownOpen(false);
    setIsConocenosDropdownOpen(false);
    setIsAnunciosDropdownOpen(false);
    setIsRegistroDropdownOpen(false);

    switch (dropdownType) {
      case "seguimiento oc - atc":
        setIsFollowUpDropdownOpen(!isFollowUpDropdownOpen);
        break;
      case "proveedores":
        setIsProveedoresDropdownOpen(!isProveedoresDropdownOpen);
        break;
      case "recursos":
        setIsRecursosDropdownOpen(!isRecursosDropdownOpen);
        break;
      case "documentación":
        setIsDocumentacionDropdownOpen(!isDocumentacionDropdownOpen);
        break;
      case "conócenos":
        setIsConocenosDropdownOpen(!isConocenosDropdownOpen);
        break;
      case "gestión de usuarios":
        setIsRegistroDropdownOpen(!isRegistroDropdownOpen);
        break;
      case "anuncios":
        setIsAnunciosDropdownOpen(!isAnunciosDropdownOpen);
        break;

      default:
        break;
    }
  };


  const handleLogout = () => {
    logout();
    navigate('/');
    window.location.reload();
  };

  const adminMenuItemsBase = [
    { icon: home, text: "INICIO", path: "/inicio" },

    {
      icon: followUp,
      text: "SEGUIMIENTO OC - ATC",
      subMenu:
        [
        { text: "OC", path: "/oc" },
        { text: "OC Histórico", path: "/oc-historico" },
        { text: "ATC", path: "/atc" },
        { text: "Facturación", path: "/facturacion"},     
        { text: "Compradores", path: "/compradores" }]
    },

    {
      icon: provider, text: "PROVEEDORES",
      subMenu:
        [{ text: "Evaluar", path: "/evaluacion" },
        { text: "Criterios de evaluación", path: "/criterios-de-evaluacion" },
        { text: "Beneficios", path: "/beneficios" }]
    },
    
    { 
      icon: resources, text: "RECURSOS",
      subMenu:
        [{ text: "Gestión de citas", path: "/gestion-de-citas"},
        { text: "Gestión de horarios", path: "/gestion-de-horarios" }]
    },

    { icon: manuals, text: "MANUALES DE INFORMACIÓN", path: "/manuales-de-informacion" },
    
    {
      icon: doc,
      text: "DOCUMENTACIÓN",
      subMenu: [
        {
          text: "Documentos",
          path: "/documentos"
        },
        {
          text: "Temporadas",
          path: "/temporadas"
        },
        {
          text: "Requisitos de inicio de temp.",
          path: "/requisitos-de-inicio-de-temporada"
        },
        { text: "Encuestas", 
          path: "/encuestas" 
        },
        {
          text: "Mis encuestas",
          path: "/mis-encuestas"
        },
        { text: "Histórico de encuestas",
          path: "/historico-de-encuestas"
        }
      ]
    },

    {icon: us, text: "CONÓCENOS", path: "/conocenos"},
    {
      icon: record, text: "GESTIÓN DE USUARIOS",
      subMenu:
        [
          { text: "Registro de usuarios", path: "/registro-usuario" },
          { text: "Usuarios administradores", path: "/lista-administrador" },
          { text: "Usuarios proveedores", path: "/lista-proveedor" },
          { text: "Usuarios compradores", path: "/lista-comprador" },
          { text: "Usuarios invitados", path: "/lista-invitado" },
        ]
    },

    {
      icon: announcement, text: "ANUNCIOS",
      subMenu:
        [{ text: "Publicar", path: "/publicar-anuncio" },
        { text: "Historial", path: "/historial-anuncios" }]
    },
  ];

  const providerMenuItemsBase = [
    { icon: home, text: "INICIO", path: "/inicio" },

    {
      icon: followUp, text: "SEGUIMIENTO OC - ATC",
      subMenu:
        [
        { text: "Mis OC", path: "/mis-oc" },
        { text: "Mis ATC", path: "/mis-atc" },
        { text: "Mi facturación", path: "/mi-facturacion"},        
        { text: "Compradores ", path: "/compradores" }
        ]
    },

    ...(hasEvaluation ? [
      {
        icon: provider, text: "PROVEEDORES",
        subMenu:
          [{ text: "Ranking", path: "/ranking" },
          { text: "Mi evaluación", path: `/mi-evaluacion/${user?.supplierId}` },
          { text: "Mis beneficios", path: "/mis-beneficios" }]
      }
    ] : []),

    
    { icon: resources, text: "RECURSOS",
      subMenu:
        [{ text: "Agendar cita", path: "/agendar-cita" }]
    },
    
    { icon: manuals, text: "MANUALES DE INFORMACIÓN", path: "/manuales-de-informacion" },
    { icon: us, text: "CONÓCENOS", path: "/conocenos" },
    
    {
      icon: doc, text: "DOCUMENTACIÓN",
      subMenu:
        [{
          text: "Requisitos de inicio de temp. ",
          path: "/requisitos-de-inicio-de-temporada"
        },
        {
          text: "Mis encuestas ",
          path: "/mis-encuestas"
        },
        ]
    },

    { 
      icon: www,
      text: "CENTRIA",
      href: "https://proveedores.centria.net/",
      target: "_blank",
      moduleId: 15
    },

    { 
      icon: www,
      text: "AULAVIRTUAL",
      href: "https://tasaproveedores.daktico.com/",
      target: "_blank",
      moduleId: 16
    },

  ];

  const adminMenuItems = filterMenuByPermissions(adminMenuItemsBase, permissions, roleId, user);
  const providerMenuItems = filterMenuByPermissions(providerMenuItemsBase, permissions, roleId, user);




const seguimientoItem = providerMenuItems.find(item => item.text === "SEGUIMIENTO OC - ATC");
if (seguimientoItem) {
}
const menuItems = (roleId === 1 || roleId === 3 || roleId === 4) ? adminMenuItems : providerMenuItems;
  const hasConfigurationPermission = hasPermission(permissions, 20);

  
const getInitials = (name) => {
  if (!name) return '--';
  const words = name.split(' ');
  return words[0]?.[0]?.toUpperCase() || '';
};

  return (
    <div className="relative">
      <div ref={menuRef} className={`fixed top-0 h-[67px] gap-2 left-0 w-full bg-white text-white p-3 sm:p-5 sm:px-5 flex justify-between items-center z-40`}>
        <div className={`flex items-center transition-all malabrigo-name ${isMenuOpen && !isPageError
            ? (screenWidth  >= 1280 ? 'xl:pl-[20.7%]' :
              screenWidth  >= 1024 ? 'pl-[23.7vw]' : 'sm:pl-4')
            : 'sm:pl-4'
          } ${isPageError ? 'pl-0 sm:pl-0' : ''}`}>
          {isPageError && (
              <div className=" h-[67px] gap-2 w-full bg-white flex justify-start items-center"
              >
                <img src={logo} alt="Logo" className="w-[47px] sm:w-[67px]" />
                <div className='h-full py-2'>
                  <div className='h-full w-[2px] bg-side-bar'></div>
                </div>
                <p className='text-xs sm:text-xl text-side-bar font-itcbold'>ConecTASA</p>
              </div>
          )}
          {!isPageError && (
          <div className="flex items-center">
            <button ref={menuButtonRef} onClick={toggleMenu} className="text-2xl text-black">
              <IoIosMenu />
            </button>
          </div>
          )}

        </div>

        <div className="flex items-center gap-3 sm:gap-7">
          <div className='flex items-center gap-2'>
            <div className='flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10'>
              <div className="flex items-center justify-center w-full h-full border-2 border-[#D9D9D9] text-white bg-side-bar rounded-full">
                <p className="text-base sm:text-lg font-itcbold">
                  {getInitials(user?.name)}
                </p>
              </div>
            </div>
            <div className="flex flex-col">
              <h2 className="sm:text-sm text-xs text-[#111928] font-itcmedium">
                {user ? `${user.name}` : 'Usuario'}
              </h2>
              <div className='flex items-center gap-1'>
                <p className="sm:text-sm text-[10px]  text-[#6B7280] font-itcbook">
                  {user ? user.role : 'Rol'}
                </p>
                {/** 
                <BiCaretDown className='text-[#374151]' />
                */}
              </div>
            </div>
          </div>

          {user?.roleId === 2 && (
            <>
          <Notification 
            isNotificationOpen={isNotificationOpen}
            onToggle={toggleNotification}
          />
          
          <button 
            onClick={() => navigate('/historico-de-notificaciones')}
            className='relative inline-block'>
            <img src={message} alt="Message-icon" className='w-full' />
            {/**
            {countMessage > 0 && (
              <span className='absolute flex items-center justify-center w-4 h-4 text-[8px] text-white rounded-full -top-[10px] -right-2 bg-[#BD002A] font-rubiklight'>
                {countMessage}
              </span>
            )}
               */}
          </button>
          </>
          )}
        </div>
      </div>

      {isMenuOpen && (
        <div className="fixed inset-0 z-40 bg-black opacity-50 lg:opacity-0 lg:hidden"
        onClick={() => toggleMenu(false)} />
      )}

      {!isPageError && (
      <div ref={menuRef}
        className={`fixed overflow-y-auto  h-full justify-between left-0 bg-side-bar text-white text-opacity-75 transition-all duration-300 ease-in-out  overflow-hidden z-40 flex flex-col
         ${isMenuOpen ? 'xl:w-[20.7vw] lg:w-[23.7vw] md:w-[33%] w-[50%]' : 'w-0'} `}>
        <SimpleBar style={{ height: '100%' }}>
          <div className='flex flex-col justify-between min-h-screen'>
            <div className='flex flex-col'>
              <div className=" h-[67px] gap-2 pl-3 sm:pl-5 pr-2 w-full bg-white flex justify-start items-center"
              >
                <img src={logo} alt="Logo" className="w-[47px] sm:w-[67px]" />
                <div className='h-full py-2'>
                  <div className='h-full w-[2px] bg-side-bar'></div>
                </div>
                <p className='text-xs sm:text-xl text-side-bar font-itcbold'>ConecTASA</p>
              </div>
              <div className='flex flex-col'>
                <div className='py-4 pt-6 pl-3 pr-2 text-xs text-white sm:pl-5 font-itcmedium md:text-sm'>
                  GENERAL
                </div>
                <div className="flex flex-col bg-side-bar ">
                  {menuItems.map((item, index) => {
                    const isItemActive = activeOption === item.text;
                    
                    let isSubItemActive = false;
                    if (item.subMenu) {
                      isSubItemActive = item.subMenu.some(subItem => activeOption === subItem.text);
                    }
                    
                    const isActive = isItemActive || isSubItemActive;
                    
                    return (
                    <React.Fragment key={index}>
                      <div
                        className={`flex items-center cursor-pointer ${isActive ? "bg-[#003758] text-white" : "bg-side-bar"} py-2 my-1 pl-3 sm:pl-5 pr-2 transition-all duration-300 ease-in-out w-[100%] hover:bg-[#003758]`}
                        onClick={() => {
                          if (item.subMenu) {
                            handleDropdownClick(item.text.toLowerCase());
                          } else {
                            handleOptionClick(
                              item.text,
                              item.path || item.href,
                              item.target,
                              item.moduleId
                            );
                          }
                        }}
                      >
                        <img src={item.icon} alt={`figure${index + 6}`} className="pr-4" />
                        <span className="text-xs md:text-sm font-itcmedium">
                          {item.text}
                        </span>
                      </div>
                      {item.subMenu && (
                        <div className={`flex flex-col w-full pl-[3.4rem] transition-all duration-500 ease-in-out 
                                      ${item.text === "SEGUIMIENTO OC - ATC" && isFollowUpDropdownOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0 overflow-hidden"} 
                                      ${item.text === "PROVEEDORES" && isProveedoresDropdownOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0 overflow-hidden"}
                                      ${item.text === "RECURSOS" && isRecursosDropdownOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0 overflow-hidden"}
                                      ${item.text === "DOCUMENTACIÓN" && isDocumentacionDropdownOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0 overflow-hidden"}
                                      ${item.text === "CONÓCENOS" && isConocenosDropdownOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0 overflow-hidden"}
                                      ${item.text === "GESTIÓN DE USUARIOS" && isRegistroDropdownOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0 overflow-hidden"}
                                      ${item.text === "ANUNCIOS" && isAnunciosDropdownOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0 overflow-hidden"}
                                    `}>
                          {item.subMenu.map((option, optionIndex) => {

                              const isSubOptionActive = activeOption === option.text;
                              
                              return (
                            <div
                              key={optionIndex}
                              className={`cursor-pointer py-1 ${isSubOptionActive ? "text-white" : ""} transition w-full`}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleOptionClick(
                                  option.text, 
                                  option.path || option.href,
                                  option.target || "_self",
                                  option.moduleId  
                                );
                              }}
                            >
                              <span className={`text-xs md:text-sm font-itcmedium ${isSubOptionActive ? "text-white" : "hover:text-white"}`}>
                                {option.text}</span>
                            </div>
                              );
                  })}
                        </div>
                      )}
                      {item.text === "INICIO" && (
                        <div className="mx-6 my-1 border-b border-white" />
                      )}
                    </React.Fragment>
                    );
})}
                </div>
              </div>
            </div>

            {/* Parte inferior del menú */}
            <div className="flex flex-col justify-center pb-4 bg-side-bar">
              <div className="mx-5 my-4 border-t border-white"></div>
              <div className='flex flex-col justify-center'>
                {hasConfigurationPermission && (
                  <div
                    className={`flex items-center py-2 pl-3 sm:pl-5 w-full pr-2 transition hover:bg-[#003758] cursor-pointer ${isPathActive('/administrar-accesos') ? "bg-[#003758] text-white" : "bg-side-bar"}`}
                    onClick={() => handleOptionClick("Configuración", "/administrar-accesos")}
                  >
                    <img src={config} alt="Configuración" className="pr-4" />
                    <p className="text-xs md:text-sm font-itcmedium">
                      ADMINISTRAR ACCESOS
                    </p>
                  </div>
                )}

                <div
                  className={`flex items-center py-2 pl-3 sm:pl-5 w-full pr-2 transition hover:bg-[#003758] cursor-pointer  ${activeOption === "Cerrar sesión" ? "bg-[#003758] text-white" : "text-white"} `}
                  onClick={handleLogout}
                >
                  <p className="text-xs md:text-sm font-itcmedium ">
                    Cerrar Sesión
                  </p>
                </div>
              </div>
              <div className='pt-4'>
                <Programate fontSize='sm:text-[13px]  text-[10px]' />
              </div>
            </div>
          </div>
        </SimpleBar>
      </div>
      )}

    </div>
  );
};

export default Menu;